<template>
    <b-card no-body :border-variant="style.border" :bg-variant="style.bg">
        <div class="card-header">
            <h4>{{ title }}</h4>
            <div v-if="instruction && instruction.file">
                <Button
                    @click="download"
                    class="b-icon btn-sm mr-1"
                >
                    <b-spinner v-if="this.downloading" small />
                    <feather-icon
                        v-else
                        icon="DownloadCloudIcon"
                    />
                </Button>
                <Button
                    @click="preview"
                    class="b-icon btn-sm"
                >
                    <feather-icon
                        icon="EyeIcon"
                    />
                </Button>
            </div>
        </div>
        <div class="card-body" v-if="instruction && (instruction.file || instruction.description)">
            <div v-if="instruction.file">
                <h5 class="text-capitalize mb-75">Document</h5>
                <p class="card-text">{{ instruction.file.name }}</p>
            </div>
            <div :class="{'mt-1': instruction.file}" v-if="instruction.description">
                <h5 class="text-capitalize mb-75">{{ $t('Component(Label):description') }}</h5>
                <p class="card-text">{{ instruction.description }}</p>
            </div>
        </div>
        <div class="card-body" v-else>
            <b-alert
                :variant="style.alert"
                show
            >
                <div class="alert-body">
                    {{ emptyText }}
                </div>
            </b-alert>
        </div>
    </b-card>
</template>

<script>
import {
    BCard, BRow, BCol, BFormCheckbox, BFormTextarea, BAlert, BSpinner
} from 'bootstrap-vue'
import Button from "@core/components/common/Button.vue";

export default {
    components: {
        Button,
        BCard, BRow, BCol, BFormCheckbox, BFormTextarea, BAlert, BSpinner
    },
    props: {
        title: {
            required: true
        },
        state: {
            default: 'default'
        },
        show: {
            type: Boolean,
            default: true
        },
        instruction: {
            required: true
        },
        emptyText: {
            type: String,
            default() {
                return 'There is no ' + this.title;
            }
        }
    },
    data() {
        return {
            downloading: false
        }
    },
    methods: {
        onChange(value) {
            this.$emit('input', value, this.instruction);
        },
        download() {
            this.downloading = true;
            this.$emit('download', this.instruction, () => this.downloading = false);
        },
        preview() {
            this.$emit('preview', this.instruction);
        }
    },
    computed: {
        style() {
            return this.$store.state.request.sent.replyVariant[this.state];
        }
    }
}
</script>
